import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import ExperiencePage from "@/pages/ExperiencePage";
import AdminPage from "@/pages/AdminPage";
import EditPage from "@/pages/EditPage";

function App() {
  return (
    <div className="App dark grain min-h-screen bg-[#050505] text-white">
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <Routes>
            <Route path="/" element={<ExperiencePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/edit/:token" element={<EditPage />} />
          </Routes>
        </ReactLenis>
      </BrowserRouter>
    </div>
  );
}

export default App;
